"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isFunction(value) {
    return typeof value === 'function';
}
function isPromise(value) {
    return (value != null &&
        (isFunction(value) || typeof value === 'object') &&
        isFunction(value.then));
}
function createInterceptor(callback) {
    var interceptor = {
        abort: false,
        setAbort: function () {
            interceptor.abort = true;
        },
        setDone: function () {
            interceptor.done = Array.from(arguments);
        },
        intercept: function (error) {
            callback(error, interceptor.setDone, interceptor.setAbort);
        },
    };
    return interceptor;
}
function runAttempt(options, callback) {
    var delay = options.delay || 0;
    var currentAttempts = options.times;
    var interceptor = createInterceptor(isFunction(options.onError) ? options.onError : function () { });
    function reattemptAsync(promise, fn, resolve, reject) {
        promise.then(resolve).catch(function (error) {
            interceptor.intercept(error);
            if (interceptor.done) {
                return resolve.apply(null, interceptor.done);
            }
            if (interceptor.abort || currentAttempts <= 0) {
                return reject(error);
            }
            setTimeout(function () {
                currentAttempts--;
                reattemptAsync(fn(), fn, resolve, reject);
            }, delay);
        });
    }
    var callbackResolver = {};
    function resetCallbackResolver() {
        callbackResolver.promise = new Promise(function (resolve) {
            function resolveCallback() {
                resolve(Array.from(arguments));
            }
            resolveCallback.resolve = resolveCallback.bind(null, null);
            resolveCallback.reject = resolveCallback.bind(null);
            callbackResolver.resolve = resolveCallback;
        });
    }
    resetCallbackResolver();
    function reattemptCallback(fn, resolve, reject) {
        callbackResolver.promise.then(function (args) {
            if (!args[0]) {
                return resolve(args.slice(1));
            }
            interceptor.intercept(args[0]);
            if (interceptor.done) {
                return resolve(interceptor.done);
            }
            if (interceptor.abort || currentAttempts <= 0) {
                return reject(args[0]);
            }
            resetCallbackResolver();
            setTimeout(function () {
                currentAttempts--;
                fn(callbackResolver.resolve);
                reattemptCallback(fn, resolve, reject);
            }, delay);
        });
    }
    return new Promise(function (resolve, reject) {
        currentAttempts--;
        var value = callback(callbackResolver.resolve);
        if (isPromise(value)) {
            callbackResolver.resolve(null);
            reattemptAsync(value, callback, resolve, reject);
        }
        else {
            reattemptCallback(callback, resolve, reject);
        }
    });
}
exports.default = {
    run: runAttempt,
};
